import React, {useEffect, useState} from 'react';
import {getFetch} from '../../../ApiBackend';
import Grid from '@material-ui/core/Grid';
import {ServiceHeader} from '../../../DNS8Components/Pages/ServiceHeader';
import {EndpointHostsTable} from './EndpointHostsTable';
import EndpointBypassTable from '../service/EndpointBypassTable';
import {useTheme} from '@material-ui/core';
import EndpointAgentInfoAndGlobalSettings
from './EndpointAgentInfoAndGlobalSettings';
import PropTypes from 'prop-types';

/**
 * EndpointAgentService component.
 *
 * @param {object} props - Component props.
 * @param {object} props.service - Service data object.
 * @return {JSX.Element} Rendered component.
 */
export default function EndpointAgentService({service}) {
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(undefined);
  const [globalAutoStart, setGlobalAutoStart] = useState(null);
  const [uiVisibility, setUiVisibility] = useState(null);

  const padding = useTheme().spacing(3);
  const clientHash = service.client_hash;
  const clientName = service.clientname;
  const serviceExpireDate = service.service_expire_date;
  const limit = service.limit;

  useEffect(() => {
    setLoading(true);
    setError(undefined);
    getFetch(`service/${clientHash}/endpoint/status`)
        .then((data) => {
          setInfo(data ?? {});
          setGlobalAutoStart(data?.autoStart === 'true');
          setUiVisibility(data?.uiVisibility === 'true');
          setLoading(false);
          setError(false);
        }).catch((_) => {
          setLoading(false);
          setError(true);
        });
  }, [clientHash]);
  return <>
    {(loading || error) && <React.Fragment>
      <Grid
        item
        xs={12}
        style={{
          paddingLeft: padding / 2,
          paddingRight: padding / 2,
        }}
      >
        <ServiceHeader
          limit={limit}
          serviceExpireDate={serviceExpireDate}
          servicename={clientName}
        />
      </Grid>
      {error &&
        <Grid
          item
          xs={12}
          style={{
            paddingLeft: padding / 2,
            paddingRight: padding / 2,
          }}
        >
          <p>No Agent Endpoint Configured </p>
        </Grid>
      }
    </React.Fragment>}
    {!loading && !error && <React.Fragment>
      <Grid
        item
        xs={12}
        style={{
          paddingLeft: padding / 2,
          paddingRight: padding / 2,
        }}
      >
        <ServiceHeader
          limit={limit}
          serviceExpireDate={serviceExpireDate}
          servicename={clientName}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          paddingLeft: padding / 2,
          paddingRight: padding / 2,
        }}
      >
        <EndpointAgentInfoAndGlobalSettings
          info={info}
          service={clientHash}
          setGlobalAutoStart={setGlobalAutoStart}
          globalAutoStart={globalAutoStart}
          uiVisibility={uiVisibility}
          setUiVisibility={setUiVisibility}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          paddingLeft: padding / 2,
          paddingRight: padding / 2,
        }}
      >
        <EndpointHostsTable
          service={clientHash}
          globalStart={globalAutoStart}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          paddingLeft: padding / 2,
          paddingRight: padding / 2,
        }}
      >
        <EndpointBypassTable
          service={clientHash}
        />
      </Grid>
    </React.Fragment>}
  </>;
}


EndpointAgentService.propTypes = {
  service: PropTypes.shape({
    client_hash: PropTypes.string.isRequired,
    clientname: PropTypes.string.isRequired,
    service_expire_date: PropTypes.oneOfType([PropTypes.string,
      PropTypes.number]),
    limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

